---
pageId: first-tracker
title: Create your first tracker
description: Start observing with Samlla using a ready-made template or the full tracker creation form.
category: getting-started
order: 1
lang: en
slug: getting-started/first-tracker
updated: 2026-08-05
---

The fastest way to understand Samlla is to create one tracker and log one entry. That single loop — record, look back, notice — is the whole product in miniature.

## Your first sign-in

On your first visit Samlla opens a single question: **"What do you want to observe?"** From there you can start with a ready-made set:

- **Pick a ready-made set.** Under "Or pick a ready-made set" you get seven starter templates — Water, Sleep, Steps, Gym, Mood, Reading, Deep work. Select any number of them and press **Add selected**; the trackers are created immediately, each already assigned to a sensible category.
- **Skip** if you prefer to look around before creating anything.

Whatever you choose, you land in the Journal. If a tracker was created, the Journal greets you with a nudge that it is ready — with an **Add entry** button that opens the quick-add form pre-targeted at that tracker.

## Creating a tracker later

From the dashboard or the trackers list, choose **Create Tracker**. The creation page offers two starting points:

- **Start from a template.** Pick a category pill (Health, Sport, Mind…) to see ready-made templates. Clicking one pre-fills the form — nothing is created yet. Review the metrics, adjust anything, then save.
- **Create your own.** Fill in the **Tracker Name**, an optional description and category, decide whether the tracker carries metrics (the **Enable metrics** switch — off means a notes-only journal tracker), define the metrics, and set the schedule.

Press **Create Tracker** and you land on the new tracker's page, ready for its first entry.

## What happens next

Your entries build up a day-by-day timeline in the Journal. Statistics grow with the data: once there is enough history, Samlla starts showing what is typical for you.

The Free plan includes 5 trackers — enough to run the full loop before deciding whether you need more.
